module.exports = __webpack_public_path__ + "static/media/runeveryday.1e128fb5.png";